import React , { useState ,useEffect  , useRef }  from "react";
import { PlusIcon, MinusIcon } from "@heroicons/react/solid";
import { Link } from "react-router-dom";
import {
useCompanyBalanceSheet
} from 'data/company';

import {number_format,APP_URL,formatINR} from 'components/config/Common';

export default function BalancesheetSection({companyinfo,type}) {
      const [openSections, setOpenSections] = useState({});

      const containerRef = useRef(null);
      const [scrolled, setScrolled] = useState(false);
    // Map to store background color of each parent section
    const parentBgMap = {};

    const toggleSection = (sectionno) => {
      setOpenSections((prev) => ({
        ...prev,
        [sectionno]: !prev[sectionno],
      }));
    };

     useEffect(() => {
          // code runs whenever `type` changes
          console.log('Type changed:', type);
          refetchPF({id:companyinfo?.id,type:(type?'Consolidated':'Standalone'),
              company_type:companyinfo?.company_type
          });
        }, [type]);

    const {
      balancesheet,
      years_list,
      lable_array:labelArray,
      isLoading: loading,
      error,
      refetch:refetchPF,
    } = useCompanyBalanceSheet({id:companyinfo?.id,type:(type?'Consolidated':'Standalone'),
      company_type:companyinfo?.company_type
    });

    console.log("balancesheet",balancesheet);
    const getTypeByName = (periodName) => {
    if (!labelArray) return null;

    const found = Object.values(labelArray).find(
      (item) => item.name.trim() === periodName.trim()
    );

  return found ? found.type : null;
};

 const getSecByName = (periodName) => {
  if (!labelArray) return null;

  const found = Object.values(labelArray).find(
    (item) => item.name.trim() === periodName.trim()
  );

  return found ? found.section : null;
};


const getPostfixByName = (periodName) => {
  if (!labelArray) return null;

  const found = Object.values(labelArray).find(
    (item) => item.name.trim() === periodName.trim()
  );

  return found ? found.postfix : null;
};

const getTextcssByName = (periodName) => {
  if (!labelArray) return null;

  const found = Object.values(labelArray).find(
    (item) => item.name.trim() === periodName.trim()
  );

  return found ? found.textbold : null;
};



/** code for scrolling */
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleScroll = () => {
      setScrolled(container.scrollLeft > 0);
    };

    container.addEventListener("scroll", handleScroll);

    return () => container.removeEventListener("scroll", handleScroll);
  }, []);


  return (
      <section className="bg-white shadow-md z-50 rounded-xl p-5">
        <h2 className="text-2xl font-semibold">Balance Sheet</h2>
        <div> Standalone Figures in Rs. Crores / {type? 
              <Link to={`${APP_URL}/company/${companyinfo?.symbol}`} className="text-accent underline ml-1">
                View Standalone
              </Link>
          : 
          <Link to={`${APP_URL}/company/${companyinfo?.symbol}/consolidated`} className="text-accent underline ml-1">
            View Consolidated
          </Link>} </div>
        <div className="py-4"></div>
        {loading?
        null
        :
        <div ref={containerRef} class="relative overflow-x-auto bg-neutral-primary-soft shadow-xs rounded-base ">
            <table 
              
             class="w-full text-sm text-left border-0 rtl:text-right text-body">
                <thead class="bg-neutral-secondary-soft border-b border-default">
                    <tr >
                        <th scope="col" class="px-6 py-2">
                           
                        </th>
                         {Object.entries(years_list).map(([keyyear, valyear]) => (
                            <th scope="col" className="px-6 py-2 ">{valyear}</th>
                          ))}
                    </tr>
                </thead>
                <tbody>
                 {Object.keys(balancesheet || {}).length === 0 ? (
                                  <div className="p-5 text-heading"> data is not ready yet , please check again
                                </div>
                                    ) : (<>
                {Object.entries(balancesheet).map(([period, qresults],index) => {
                    const type = getTypeByName(period); // or value.name
                  const sectionno = getSecByName(period);

                    const postfix = getPostfixByName(period);
                  const textbold = getTextcssByName(period);


                  // If this is a parent row → compute & store bg
                    if (type === "parent") {
                      parentBgMap[sectionno] =
                        index % 2 === 0
                          ? "bg-gray-50"
                          : "bg-neutral-secondary-soft";
                    }

                    // Now rowBg ALWAYS exists (because child uses parent's stored bg)
                    const rowBg = parentBgMap[sectionno] || "bg-white";

                  // Find all children belonging to this section
                  const children = Object.entries(balancesheet).filter(
                    ([p, data]) => getSecByName(p) === sectionno && getTypeByName(p) === "child"
                  );
                   console.log("childrenlist",rowBg);
                  const hasChild = children.length > 0;
                  
                  return(<React.Fragment key={sectionno}>  
                   {type === "parent" &&
                   <tr 
                   className={`${rowBg} ${textbold} cursor-pointer ${openSections[sectionno] ? "border-t-2 " : ""}  `}
                  onClick={() => type === "parent" && toggleSection(sectionno)}                      >
                    
                      <td className={`px-6 py-2 sticky left-0 z-20 ${scrolled ? "bg-gray-100" : ""} `} >
                        <div className={`flex gap-1 whitespace-nowrap items-center ${openSections[sectionno] ? "text-accent " : "text-heading"} `}>{period}
                            {hasChild && (
                        <> {openSections[sectionno] ? (
                              <MinusIcon className="w-3 h-3 text-accent" />
                            ) : (
                              <PlusIcon className="w-3 h-3 text-accent" />
                            )}</>
                          )}
                          </div>
                        </td>


                      {Object.entries(qresults).map(([key, qresultsval]) => (
                         
                          <td className={`px-6 py-2 text-heading  text-wrap `} >{qresultsval ? <>{formatINR(qresultsval,2)}{postfix}</> : null} </td>
                      ))}
                      </tr>
                    }
                      {openSections[sectionno] && type === 'child' &&
                       <tr 
                         className={`${rowBg}  cursor-pointer`}
>                    
                      <td className={`px-6 py-2 text-heading flex gap-1 whitespace-nowrap items-center`} >
                        {period}
                        </td>
                      {Object.entries(qresults).map(([key, qresultsval]) => (
                         
                          <td className={`px-6 py-2 text-heading whitespace-nowrap`} >{qresultsval} {postfix}</td>
                      ))}
                      </tr>}
                    
                   </React.Fragment>)
                })}
                 </>
                                    )}  
                </tbody>
            </table>
        </div>
        }
      </section> 
  );
}
